export default {
  configuration: {
    showPackageCategoryNotWorking: 'Hiển thị danh mục gói không hoạt động',
    showPackageCategory: 'Hiển thị danh mục gói',
    showPackageNotWorking: 'Hiển thị gói không hoạt động',
    showPackageExpired: 'Hiển thị gói đã hết hạn',
    package: 'Gói',
    packageDetail: 'Chi tiết gói',
    addTransactionNightly: 'Thêm giao dịch hàng đêm',
    addTransactionDaily: 'Thêm giao dịch hàng ngày',
    addTransactionExceptFirstDay: 'Thêm giao dịch các ngày trừ ngày đầu tiên',
    addTransactionOnFirstDay: 'Thêm giao dịch vào ngày đầu tiên',
    addTransactionOnLastDay: 'Thêm giao dịch vào ngày cuối cùng',
    fixedPrice: 'Giá cố định',
    adultAndChild: 'Người lớn và trẻ em',
    adult: 'Người lớn',
    child: 'Trẻ em',
    generalInformation: 'Thông tin chung',
    transactionDetail: 'Chi tiết giao dịch',
    attribute: 'Thuộc tính',
    configurationDisplay: 'Cấu hình hiển thị',
    includeInRoomRate: 'Bao gồm trong giá phòng',
    addToPriceCode: 'Cộng thêm vào mã giá',
    distinctFlow: 'Dòng riêng biệt',
    includeInRoomRateFlow: 'Chung với dòng tiền phòng',
    detailInformationOfPackage: 'Thông tin chi tiết của gói',
    priceCodeInformation: 'Thông tin mã giá',
    statistic: 'Thống kê',
    pricePeriod: 'Giá giai đoạn',
    priceRoomLevelByPeriod: 'Giá hạng phòng theo giai đoạn',
    unselectedPackageAndGroupPackageList: 'Danh sách gói/Nhóm gói chưa chọn',
    selectedPackageAndGroupPackageList: 'Danh sách gói/Nhóm gói đã chọn',
    unselectedProductAndServiceList: 'Danh sách sản phẩm/Dịch vụ chưa chọn',
    selectedProductAndServiceList: 'Danh sách sản phẩm/Dịch vụ đã chọn',
    showPackageGroup: 'Hiển thị nhóm gói',
    promotionDetail: 'Chi tiết khuyến mại',
    condition: 'Điều kiện',
    allDepartments: 'Tất cả các bộ phận',
    applyForBookingRoom: 'Áp dụng cho đặt phòng'
  }
}
